import { Component, Inject, OnInit } from '@angular/core';
import { QuotationComponent } from '../../quotation/quotation.component';
import { AccessoriesOtherComponent } from './accessories-other/accessories-other.component';
import { MessageComponent } from '../message/message.component';
import { MatCheckboxChange, MatCheckbox } from '@angular/material/checkbox';
import { AccesoryAmount } from '../../../shared/models/quotation-model/catalogs/accessory-amount.model';
import { AccessoryDelete } from '../../../shared/models/quotation-model/catalogs/accessory-delete.model';
import { AccessoryInsert } from '../../../shared/models/quotation-model/catalogs/accessory-insert.model';
import { Accessory } from '../../../shared/models/quotation-model/catalogs/accessory.model';
import { AccessoryQuotationUpdate } from '../../../shared/models/quotation-model/main/accessory-quotation-update.model';
import { AccessoryQuotation } from '../../../shared/models/quotation-model/main/accessory-quotation.model';
import { AccesoryService } from '../../../shared/services/quotation/catalogs/accesories.service';
import { QuotationService } from '../../../shared/services/quotation/quotation.service';
import { MatFormFieldModule, MatLabel } from '@angular/material/form-field';
import { MatOption, MatSelect } from '@angular/material/select';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { NgxMaskDirective } from 'ngx-mask';
import { MatIcon } from '@angular/material/icon';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-quotation-accessories',
  templateUrl: './quotation-accessories.component.html',
  styleUrls: ['./quotation-accessories.component.scss'],
  standalone: true,
  imports: [
    MatFormFieldModule,
    ReactiveFormsModule,
    MatInputModule,
    MatOption,
    MatCheckbox,
    MatLabel,
    MatSelect,
    FormsModule,
    TranslateModule,
    MatButtonModule,
    NgxMaskDirective,
    MatIcon,
    MatTableModule,
  ],
})
export class QuotationAccessoriesComponent implements OnInit {
  displayedColumns: string[] = ['Descripcion', 'Precio', 'FinanciadoContado', 'Rent', 'Delete'];

  desactiveControl: boolean = false;
  accessories: Accessory[] = [];
  quotationAccessories: AccessoryQuotation[] = [];
  accessoryAmount!: AccesoryAmount;
  insertAccessoryObj!: AccessoryInsert;
  insertOtherAccessory!: AccessoryInsert;
  additionalId: any;
  updateQuotationAccessoryItem!: AccessoryQuotationUpdate;
  accessoryInputs: any[] = [];
  accessorySelects: any[] = [];
  accessorysCheckbox: any[] = [];
  accessoryDescription: any[] = [];

  accessoryDelete!: AccessoryDelete;

  constructor(
    public dialogRef: MatDialogRef<QuotationComponent>,
    private quoatationService: QuotationService,
    private accessoryService: AccesoryService,
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public obj: any,
  ) {}

  ngOnInit(): void {
    this.loadAccessorys();
    this.loadQuotationAccessories();
    this.loadAccesoryAmount();
  }

  loadQuotationAccessories() {
    this.quoatationService.getAccessorys(this.obj.quotationId).subscribe((response) => {
      this.quotationAccessories = response;
      this.loadInputs();
    });
  }

  loadInputs() {
    this.quotationAccessories.forEach((item) => {
      this.accessoryInputs[item.id] = item.cost;
      this.accessorySelects[item.id] = item.isFinanced;
      this.accessorysCheckbox[item.id] = item.isInIncome;
      this.accessoryDescription[item.id] = item.accesoryDescription;
    });
  }

  loadAccessorys() {
    this.accessoryService.getAccessories(this.obj.quotationId).subscribe((response) => {
      this.accessories = response;
    });
  }

  loadAccesoryAmount() {
    this.accessoryAmount = {
      id: null,
      maximumPercentage: 0,
      totalAccessories: 0,
      cashAccessories: 0,
      financedAccessories: 0,
    };
    this.accessoryService.getAccessoriesAmount(this.obj.quotationId).subscribe((response) => {
      this.accessoryAmount = response;
    });
  }

  insertAccessory() {
    this.insertAccessoryObj = {
      quotationId: this.obj.quotationId,
      aditionalId: this.additionalId,
    } as AccessoryInsert;
    this.accessoryService.addAccessory(this.insertAccessoryObj).subscribe((response) => {
      this.loadQuotationAccessories();
      this.loadAccesoryAmount();
      this.loadAccessorys();
    });
  }

  onChangeAccessory(event: any) {
    const option = event.source.selected;
    this.additionalId = option.value;
  }

  onChangeIncome(event: any, element: AccessoryQuotation) {
    const option = event.source.selected;
    this.accessorySelects[element.id] = option.value;
    this.updateAccesory(element);
  }

  keyPressNumbersWithDecimal(event: KeyboardEvent) {
    var charCode = event.which ? event.which : event.keyCode;
    if (charCode != 46 && charCode > 31 && (charCode < 48 || charCode > 57)) {
      event.preventDefault();
      return false;
    }
    return true;
  }

  updateAccesory(element: AccessoryQuotation) {
    var isInComeVar = 0;
    var accesoryDescriptionData = '';
    if (this.accessorysCheckbox[element.id] != undefined) {
      isInComeVar = this.accessorysCheckbox[element.id];
    }

    if (element.accesoryDescription === 'BLINDAJE' || element.accesoryDescription === 'CAJA') {
      accesoryDescriptionData = element.accesoryDescription;
    } else {
      accesoryDescriptionData = this.accessoryDescription[element.id];
    }
    this.updateQuotationAccessoryItem = {
      accessoryId: element.id,
      accessoryDescription: accesoryDescriptionData,
      cost: this.accessoryInputs[element.id],
      isFinanced: this.accessorySelects[element.id],
      isInIncome: isInComeVar,
      quotationId: this.obj.quotationId,
    };
    this.quoatationService
      .updateAccessory(this.updateQuotationAccessoryItem)
      .subscribe((response) => {
        this.loadQuotationAccessories();
        this.loadAccesoryAmount();
        this.loadAccessorys();
      });
  }

  openDialogConfirm(element: AccessoryQuotation) {
    this.accessoryDelete = { quotationId: this.obj.quotationId, accessoryId: element.id };
    const dialogRef = this.dialog.open(MessageComponent, {
      width: '350px',
      data: { quotationId: this.obj.quotationId, accessoryId: element.id },
      panelClass: 'dialog-container-custom',
    });

    dialogRef.afterClosed().subscribe((result) => {
      this.loadQuotationAccessories();
      this.loadAccesoryAmount();
      this.loadAccessorys();
    });
  }

  openDialogOtherAccesory(additionalIdItem: number) {
    const dialogRef = this.dialog.open(AccessoriesOtherComponent, {
      width: '500px',
      data: { quotationId: this.obj.quotationId, additionalId: additionalIdItem },
    });

    dialogRef.afterClosed().subscribe((result) => {
      this.loadQuotationAccessories();
      this.loadAccesoryAmount();
      this.loadAccessorys();
    });
  }

  returnFinanced(valor: number): number {
    var salida = valor;
    return salida;
  }

  onCheckIncome(event: MatCheckboxChange, element: AccessoryQuotation) {
    var isIncome = event.checked ? 1 : 0;
    this.accessorysCheckbox[element.id] = isIncome;
    this.updateAccesory(element);
  }

  closeAccessory() {
    this.dialogRef.close();
  }

  public closeModal(): void {
    this.dialogRef.close(null);
  }

  public confirmAndCloseModal(): void {
    this.dialogRef.close(true);
  }
}
